(function () {
  const grid = document.getElementById('f2w-agenda-grid');
  const pagination = document.getElementById('f2w-agenda-pagination');
  const sportFilterEl = document.getElementById('f2w-agenda-filters-sport');
  const yearFilterEl = document.getElementById('f2w-agenda-filters-year');
  const dataEl = document.getElementById('f2w-agenda-data');
  if (!grid || !dataEl) return;

  const CTA = grid.dataset.cta || 'Full event info →';
  const EMPTY = grid.dataset.empty || 'Geen evenementen gevonden.';
  const PER_PAGE = 12;
  const TODAY = new Date().toISOString().slice(0, 10);
  const CURRENT_YEAR = new Date().getFullYear().toString();

  const months = ['januari','februari','maart','april','mei','juni','juli','augustus','september','oktober','november','december'];

  let allEvents = [];
  let filteredEvents = [];
  let currentPage = 1;
  let activeSport = 'alle';
  let activeYear = CURRENT_YEAR;

  try {
    allEvents = JSON.parse(dataEl.textContent);
  } catch(e) {
    grid.innerHTML = `<p class="rte">${EMPTY}</p>`;
    return;
  }

  function formatDate(str) {
    if (!str) return '';
    const d = new Date(str);
    return `${String(d.getDate()).padStart(2,'0')} ${months[d.getMonth()]} ${d.getFullYear()}`;
  }

  function buildFilters() {
    const sportsMap = new Map();
    allEvents.forEach(e => (e.sports || []).forEach(s => {
      if (s.handle && !sportsMap.has(s.handle)) sportsMap.set(s.handle, s.name);
    }));
    const sports = Array.from(sportsMap.entries()).sort((a, b) => a[1].localeCompare(b[1], 'nl'));

    sportFilterEl.innerHTML = '';
    sportFilterEl.appendChild(makeFilterBtn('alle', 'Alle sporten', activeSport === 'alle', 'sport'));
    sports.forEach(([handle, name]) => {
      sportFilterEl.appendChild(makeFilterBtn(handle, name, activeSport === handle, 'sport'));
    });

    const years = [...new Set(allEvents.map(e => (e.date_start || '').slice(0, 4)).filter(Boolean))].sort((a, b) => b - a);
    yearFilterEl.innerHTML = '';
    years.forEach(year => {
      yearFilterEl.appendChild(makeFilterBtn(year, year, activeYear === year, 'year'));
    });
  }

  function makeFilterBtn(value, label, active, type) {
    const btn = document.createElement('button');
    btn.dataset.value = value;
    btn.dataset.type = type;
    btn.textContent = label;
    btn.style.cssText = `padding:6px 14px;border:1px solid var(--color-border);border-radius:20px;background:${active ? 'var(--color-accent)' : '#fff'};color:${active ? 'var(--color-accent-text,#fff)' : 'inherit'};font-size:0.85rem;font-weight:${active ? '700' : '400'};cursor:pointer;transition:background 0.15s;`;
    btn.addEventListener('click', () => {
      if (type === 'sport') {
        activeSport = value;
        document.querySelectorAll('#f2w-agenda-filters-sport button').forEach(b => setActive(b, b.dataset.value === value));
      } else {
        activeYear = value;
        document.querySelectorAll('#f2w-agenda-filters-year button').forEach(b => setActive(b, b.dataset.value === value));
      }
      currentPage = 1;
      applyFilters();
    });
    return btn;
  }

  function setActive(btn, active) {
    btn.style.background = active ? 'var(--color-accent)' : '#fff';
    btn.style.color = active ? 'var(--color-accent-text,#fff)' : 'inherit';
    btn.style.fontWeight = active ? '700' : '400';
  }

  function applyFilters() {
    let result = allEvents.filter(e => {
      const yearMatch = (e.date_start || '').slice(0, 4) === activeYear;
      const sportMatch = activeSport === 'alle' || (e.sports || []).some(s => s.handle === activeSport);
      return yearMatch && sportMatch;
    });

    const upcoming = result.filter(e => e.date_start >= TODAY).sort((a, b) => a.date_start.localeCompare(b.date_start));
    const past = result.filter(e => e.date_start < TODAY).sort((a, b) => b.date_start.localeCompare(a.date_start));
    filteredEvents = [...upcoming, ...past];

    renderPage(1);
  }

  function renderPage(page) {
    currentPage = page;
    const start = (page - 1) * PER_PAGE;
    const slice = filteredEvents.slice(start, start + PER_PAGE);

    grid.innerHTML = slice.length ? slice.map(e => `
      <article style="border:1px solid var(--color-border);border-radius:var(--block-border-radius,4px);overflow:hidden;display:flex;flex-direction:column;background:var(--color-article-card-bg,#fff);">
        ${e.cover_image ? `
          <div style="aspect-ratio:16/9;overflow:hidden;">
            <img src="${e.cover_image}" alt="${(e.name||'').replace(/"/g,'&quot;')}" width="600" loading="lazy" style="width:100%;height:100%;object-fit:cover;display:block;">
          </div>` : ''}
        <div style="padding:16px;display:flex;flex-direction:column;flex:1;">
          <div style="display:flex;flex-wrap:wrap;gap:6px;align-items:center;margin-bottom:8px;">
            ${(e.sports||[]).map(s => `<span style="font-size:10px;font-weight:600;text-transform:uppercase;letter-spacing:0.08em;background:var(--color-accent);color:var(--color-accent-text,#fff);padding:2px 8px;border-radius:2px;">${s.name}</span>`).join('')}
            <time style="font-size:11px;color:#888;" datetime="${e.date_start}">${formatDate(e.date_start)}</time>
          </div>
          <h2 style="font-size:1.1rem;margin:0 0 8px;">${e.name||''}</h2>
          ${(e.location_name || e.city) ? `
            <p style="font-size:0.85rem;margin:0 0 10px;color:#555;">
              📍 ${[e.location_name, e.city, e.country].filter(Boolean).join(', ')}
            </p>` : ''}
          ${e.description ? `<div class="rte" style="font-size:0.875rem;margin-bottom:12px;">${e.description}</div>` : ''}
          ${e.external_url ? `<a href="${e.external_url}" class="cib__bekijk-btn cib__atc-btn" target="_blank" rel="noopener" style="margin-top:auto;">${CTA}</a>` : ''}
        </div>
      </article>
    `).join('') : `<p class="rte">${EMPTY}</p>`;

    renderPagination();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function renderPagination() {
    const totalPages = Math.ceil(filteredEvents.length / PER_PAGE);
    if (totalPages <= 1) { pagination.innerHTML = ''; return; }

    pagination.innerHTML = Array.from({ length: totalPages }, (_, i) => {
      const p = i + 1;
      const active = p === currentPage;
      return `<button data-page="${p}" style="padding:6px 14px;border:1px solid var(--color-border);border-radius:var(--block-border-radius,4px);background:${active ? 'var(--color-accent)' : '#fff'};color:${active ? 'var(--color-accent-text,#fff)' : 'inherit'};font-weight:${active ? '700' : '400'};cursor:pointer;">${p}</button>`;
    }).join('');

    pagination.querySelectorAll('button').forEach(btn => {
      btn.addEventListener('click', () => renderPage(parseInt(btn.dataset.page)));
    });
  }

  buildFilters();
  applyFilters();
})();
